const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_MASTER_DATA",
    modulePath: "hml-new-netsuite.masterdata", // 'masterdata' || 'homol.masterdata'
    moduleName: "masterdata",
    language: "pt",
    port: 8082,
    theme: "venturus.js",
    env: "hml-new-netsuite", // 'prod' || 'homol'
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
